<template>
	<div class="rent-box text-center">
		<nav class="display-flex-between flex-align-center">
			<div v-for="(item, index) in typeList" :key="index" class="item select-point" :class="{ active: item.typeId == askData.typeId }" @click="changeType(item)" @mouseenter="initProducts(item)">
				<span class="image bg-contain" :class="['type-' + item.typeId]"></span>
				<p>{{ item.typeName }}</p>
				<div class="item-active">
					<span class="image bg-contain" :class="['type-' + item.typeId + '-white']"></span>
					<p>{{ item.typeName }}</p>
				</div>
			</div>
		</nav>
		<div class="flex">
			<div class="aside-wrap">
				<span class="aside bg-cover" :class="['aside-' + item.typeId, item.typeId == askData.typeId ? 'active' : '']" v-for="(item, index) in typeList" :key="index"></span>
			</div>
			<ul class="product-list" v-for="(item1, index1) in typeList" :key="index1" v-show="item1.typeId == askData.typeId">
				<template v-if="item1.listData">
					<li v-for="(item, index) in item1.listData" :key="index" class="vertical-top relative">
						<!-- <span class="image bg-contain" :style="{'background-image':'url('+item.product_image_url+')'}"></span> -->
						<span class="image bg-contain" style="position:relative;padding-bottom: 100%;">
							<img :src="item.product_image_url" alt="" style="position: absolute;top:0;left:0;display:block;width: 100%;height: 100%;object-fit: cover;">
						</span>
						<p class="name line-ellipsis">{{ item.name }}</p>
						<p class="rent">¥{{ item.rent }}/{{ item.rentUnit }}起</p>
						<div class="code-wrap flex-center">
							<div class="content">
								<qriously :value="'alipays://platformapi/startapp?appId=2017082408357898&page=pages/productDetails/productDetails&query=productId%3d' + item.product_id" :size="125" class="code" />
								<p>打开支付宝扫码<br />特惠免押租</p>
							</div>
						</div>
					</li>
				</template>
				<template v-else>
					<li v-for="(item, index) in listData" :key="index" class="vertical-top relative">
						<span class="image bg-contain"></span>
						<p class="name"></p>
						<p class="rent"></p>
					</li>
				</template>
			</ul>
		</div>
		<img class="slide-btn" src="~@assets/img/slide-right.png" @click="slide('next')">
		<img class="slide-btn btn-left" src="~@assets/img/slide-right.png" @click="slide('prev')">
	</div>
</template>

<script>
import Vue from 'vue'
import { CONFIG, network } from '@assets/js/apis';
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
export default {
	data() {
		return {
			askData: {
				pageNumber: 1,
				pageSize: 8,
				typeId: 0,
				orderBy: 'new'
			},
			typeList: [],
			listData: new Array(8),
		}
	},
	created() {
		network(CONFIG.frontTypeList).then(res => {
			let typeList = []
			if (res && res.details) {
				res.details.forEach(item => {
					typeList.push({
						typeId: item.productTypeId,
						typeName: item.productTypeName
					})	
				})
			}
			this.typeList = typeList
			if (this.typeList.length) {
				this.askData.typeId = this.typeList[0].typeId;
				// this.getProducts();
				this.initProducts(this.typeList[0]);
			}
		});
	},
	methods: {
		getProducts() {
			network(CONFIG.products, this.askData).then(res => {
				this.listData = res.details.data;
				this.typeList.find(item => item.typeId == this.askData.typeId).listData = res.details.data;
			});
		},
		changeType(item) {
			this.askData.typeId = item.typeId;
			// if(item.listData){
			// 	this.listData = item.listData;
			// }else{
			// 	this.getProducts();
			// }
			this.initProducts(item);
		},
		slide(type) {
			let activeItem = this.typeList.find(item => item.typeId == this.askData.typeId);
			let activeIndex = this.typeList.indexOf(activeItem);
			if ((type == 'prev' && !activeIndex) || (type == 'next' && activeIndex == (this.typeList.length - 1))) return
			activeIndex = type == 'prev' ? activeIndex - 1 : activeIndex + 1;
			this.askData.typeId = this.typeList[activeIndex].typeId;
			this.initProducts(this.typeList[activeIndex]);
		},
		initProducts(item) {
			if (!item.listData) {
				let askData = Object.assign({}, this.askData);
				askData.typeId = item.typeId;
				network(CONFIG.products, askData).then(res => {
					Vue.set(item, 'listData', res.details.data)
				});
			}
		}
	}
}
</script>

<style lang="scss">
.rent-box {
	position: relative;
	background: #ffffff;

	nav {
		background: #FAFAFA;
		padding: 10px;

		.item {
			position: relative;
			flex: 1;
			padding-bottom: 6px;
			border-radius: 4px;
			transition: background 0.2s;
			overflow: hidden;

			// &.active{
			// 	background: #3ed8c4;
			// 	color: #ffffff;
			// 	&::after{
			// 		display: none;
			// 	}
			// }
			.item-active {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				background: #3ed8c4;
				color: #ffffff;
				height: 0;
				overflow: hidden;
				transition: height 0.2s;
				z-index: 3;
			}

			&.active .item-active {
				height: 100%;
			}

			&:not(:last-child)::after {
				content: '';
				position: absolute;
				top: 50%;
				right: 0;
				width: 1px;
				height: 50px;
				margin-top: -25px;
				background: #eeeeee;
			}

			.image {
				display: block;
				width: 38px;
				height: 38px;
				margin: auto auto 1px;

				&.type-1 {
					background-image: url('https://resource.tanwuapp.com/FvG-h2SaJtRgDHmiGNk41EyUzDx3');
				}

				&.type-1-white {
					background-image: url('https://resource.tanwuapp.com/FvdspMpVtGCQi32aqZLOnpFgQMtY');
				}

				&.type-3 {
					background-image: url('https://resource.tanwuapp.com/Fm8wbJVfXHRlCI-rRL3zsxv1jg5c');
				}

				&.type-3-white {
					background-image: url('https://resource.tanwuapp.com/Frhx3MgweCEFnVvRDnv3r3P3lORr');
				}

				&.type-5 {
					background-image: url('https://resource.tanwuapp.com/Ftxmq_dNBLrPl_U9Zy4G8ujw063g');
				}

				&.type-5-white {
					background-image: url('https://resource.tanwuapp.com/FqapAuNvK49221AYriiqbptuAv3s');
				}

				&.type-8 {
					background-image: url('https://resource.tanwuapp.com/FgfHjqbNku74PaEVXKyijwdPMgNx');
				}

				&.type-8-white {
					background-image: url('https://resource.tanwuapp.com/FuJdct9U0X3vjQaNakvJufByFY_z');
				}

				&.type-9 {
					background-image: url('https://resource.tanwuapp.com/FkqxAi64vKmqv5n9-QaYFlkGQ_Xh');
				}

				&.type-9-white {
					background-image: url('https://resource.tanwuapp.com/FtRP9_UBvMnmNu1JnrjNO_dKnq_6');
				}

				&.type-10 {
					background-image: url('https://resource.tanwuapp.com/Fl9zvPn0k0wld6kGugiSLsECaoOz');
				}

				&.type-10-white {
					background-image: url('https://resource.tanwuapp.com/FnFmMgJwpoVEAxaFIxCmIPuskpby');
				}

				&.type-11 {
					background-image: url('https://resource.tanwuapp.com/FqJHiq7BIHbYduqynwc-S9NjfXNk');
				}

				&.type-11-white {
					background-image: url('https://resource.tanwuapp.com/FtBIZ8UZBmn_e3McS2YQRyyo2hSz');
				}

				&.type-18 {
					background-image: url('https://resource.tanwuapp.com/pc/type-18-icon.png');
				}

				&.type-18-white {
					background-image: url('https://resource.tanwuapp.com/pc/type-18-icon-active.png');
				}

				&.type-19 {
					background-image: url('https://resource.tanwuapp.com/pc/type-19-icon.png');
				}

				&.type-19-white {
					background-image: url('https://resource.tanwuapp.com/pc/type-19-icon-active.png');
				}

				&.type-13 {
					background-image: url('https://resource.tanwuapp.com/pc/type-13-icon.png');
				}

				&.type-13-white {
					background-image: url('https://resource.tanwuapp.com/pc/type-13-icon-active.png');
				}

				&.type-14 {
					background-image: url('https://resource.tanwuapp.com/pc/type-14-icon.png');
				}

				&.type-14-white {
					background-image: url('https://resource.tanwuapp.com/pc/type-14-icon-active.png');
				}

				&.type-15 {
					background-image: url('https://resource.tanwuapp.com/pc/type-15-icon.png');
				}

				&.type-15-white {
					background-image: url('https://resource.tanwuapp.com/pc/type-15-icon-active.png');
				}

				&.type-16 {
					background-image: url('https://resource.tanwuapp.com/pc/type-16-icon.png');
				}

				&.type-16-white {
					background-image: url('https://resource.tanwuapp.com/pc/type-16-icon-active.png');
				}

				&.type-20 {
					background-image: url('https://prod-static.tanwuapp.com/official-website/type-20-icon.png');
				}

				&.type-20-white {
					background-image: url('https://prod-static.tanwuapp.com/official-website/type-20-icon-active.png');
				}
			}
		}
	}

	.aside-wrap {
		position: relative;
		width: 22%;
		margin: 15px;
		margin-right: 2px;
		border-radius: 3px;
		background-color: #FAFAFA;

		.aside {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			opacity: 0;
			transition: opacity 0.3s;

			&.aside-1 {
				background-image: url('https://resource.tanwuapp.com/Ftw5osqS6R_X-Kx4GFvOw182kEFB');
			}

			&.aside-3 {
				background-image: url('https://resource.tanwuapp.com/FsSuSWNF5gTGOB6aeIDFqojhIygV');
			}

			&.aside-5 {
				background-image: url('https://resource.tanwuapp.com/Fk9a7xhuyOU_UVekv_gnpcCGeIEO');
			}

			&.aside-8 {
				background-image: url('https://resource.tanwuapp.com/Fn5J_Dybn3sec0An_Sw9ENlvkqU8');
			}

			&.aside-9 {
				background-image: url('https://resource.tanwuapp.com/FjiMwCgsxckEnzPzoqxr0KD6WGER');
			}

			&.aside-10 {
				background-image: url('https://resource.tanwuapp.com/FnQ1wIUQek2JZVTjNfhR3JeF4XYF');
			}

			&.aside-11 {
				background-image: url('https://resource.tanwuapp.com/Fre8sceiPGcekedllZWkKH366chI');
			}

			&.aside-18 {
				background-image: url('https://resource.tanwuapp.com/pc/type-18-big.png');
			}

			&.aside-19 {
				background-image: url('https://resource.tanwuapp.com/pc/type-19-big.png');
			}

			&.aside-13 {
				background-image: url('https://resource.tanwuapp.com/pc/type-13-big.png');
			}

			&.aside-14 {
				background-image: url('https://resource.tanwuapp.com/pc/type-14-big.png');
			}

			&.aside-15 {
				background-image: url('https://resource.tanwuapp.com/pc/type-15-big.png');
			}

			&.aside-16 {
				background-image: url('https://resource.tanwuapp.com/pc/type-16-big.png');
			}

			&.aside-20 {
				background-image: url('https://prod-static.tanwuapp.com/official-website/type-20-big.png');
			}

			&.active {
				opacity: 1;
			}
		}
	}

	.product-list {
		flex: 1;

		li {
			width: 25%;
			padding: 6px 15px 26px;
			box-sizing: border-box;
			cursor: pointer;

			&:not(:nth-child(4n+1)) {
				border-left: 1px solid #FAFAFA;
			}

			&:not(:nth-child(-n+3)) {
				border-top: 1px solid #FAFAFA;
			}

			.image {
				display: block;
				// height: 174px;
				padding-bottom: 87.8787%;
			}

			.name {
				font-size: 14px;
				margin-top: 32px;
				margin-bottom: 10px;
				height: 19px;
			}

			.rent {
				height: 21px;
			}

			.code-wrap {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				opacity: 0;
				line-height: 26px;
				z-index: 2;
				transition: all 0.3s;
				background: #ffffff;

				.content {
					transition: all 0.3s;
					transition-delay: 0.1s;
					transform: translateY(20px);
					opacity: 0;

					.code {
						margin-bottom: 28px;
						border: 2px solid #000000;
						border-radius: 10px;
						padding: 6px;

						canvas {
							display: block;
						}
					}
				}
			}

			&:hover {
				z-index: 10;

				.code-wrap {
					box-shadow: 0 6px 20px rgba($color: #000000, $alpha: 0.1);
					opacity: 1;

					.content {
						opacity: 1;
						transform: translateY(0);
						margin-top: 0;
					}
				}
			}
		}
	}

	.slide-btn {
		width: 54px;
		height: 54px;
		position: absolute;
		right: -170px;
		top: 50%;
		margin-top: -27px;
		opacity: 0.4;
		cursor: pointer;
		transition: 0.2s;

		&.btn-left {
			left: -170px;
			right: auto;
			transform: rotate(180deg);
		}

		&:hover {
			opacity: 1;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/rentBox.vue